var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 13.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72 13.84A1.71 1.71 0 0 1 0 12.12V1.72A1.71 1.71 0 0 1 1.72 0h20.56a1.74 1.74 0 0 1 .42.05V.1A1.71 1.71 0 0 1 24 1.72v10.4a1.71 1.71 0 0 1-1.72 1.72zm19.6-1.55l-4.45-5-2.53 2.18a3.48 3.48 0 0 1-2.31.86 3.57 3.57 0 0 1-2.3-.83L7.07 7.21l-4.49 5.08zm1.13-1.06V2.35L18 6.23zm-20.9-.12L5.9 6.2 1.55 2.46zm9.19-2.78a2 2 0 0 0 2.58 0L21 1.55H2.86z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db47dc55f331e42730afc848a777934f.svg";
export { ForwardRef as ReactComponent };